import axios from "axios"
import { BaseUrl, JsonConfig } from "./BaseRepository";
import { ErrorMessage } from "../Utils/Utils";

export const selectMasterfileFrequency = async (props) => {
    let value = props;
    try {
        let url;
        if (value === "Weekly") {
            url = `${BaseUrl}Paychex/GettingdatafromMasterFile?Frequency=Weekly`
        }
        else {
            url = `${BaseUrl}Paychex/GettingdatafromMasterFile?Frequency=Bi-Weekly`
        }
        const res = await axios.get(url, JsonConfig);
        let tempdata = res.data;
        const tempList = JSON.parse(tempdata.payload)
        let len = tempList.length;
        let loopList = []
        for (let i = 0; i < len; i++) {
            const hrdt = new Date(tempList[i].hire_date)
            var newHiredt = parseInt(hrdt.getMonth() + 1) + '/' + parseInt(hrdt.getDate()) + '/' + parseInt(hrdt.getFullYear());
            let trmdt;
            var newTermdt;
            if (tempList[i].term_date !== null) {
                if (tempList[i].term_date !== undefined) {
                    trmdt = new Date(tempList[i].term_date);
                    newTermdt = parseInt(trmdt.getMonth() + 1) + '/' + parseInt(trmdt.getDate()) + '/' + ('0' + '0' + '0' + '0' + parseInt(trmdt.getFullYear())).slice(-4);
                }
            }
            const pydt = new Date(tempList[i].payDate)
            var newPaydt = parseInt(pydt.getMonth() + 1) + '/' + parseInt(pydt.getDate()) + '/' + parseInt(pydt.getFullYear());
            loopList.push({
                Id: tempList[i].Id,
                comp_code: tempList[i].comp_code,
                file_number: tempList[i].file_number,
                pcx_emp_name: tempList[i].pcx_emp_name,
                portal_emp_name: tempList[i].portal_emp_name,
                state: tempList[i].state,
                client: tempList[i].client,
                hire_date: newHiredt,
                rate_type: tempList[i].rate_type,
                pay_rate: tempList[i].pay_rate,
                pay_frequency: tempList[i].pay_frequency,
                flsa: tempList[i].flsa,
                term_date: newTermdt,
                emp_status: tempList[i].emp_status,
                period: tempList[i].period,
                temp_rate: tempList[i].temp_rate,
                rt_wk1: tempList[i].rt_wk1,
                ot_wk1: tempList[i].ot_wk1,
                dt_wk1: tempList[i].dt_wk1,
                status_W: tempList[i].status_W,
                rt_wk2: tempList[i].rt_wk2,
                ot_wk2: tempList[i].ot_wk2,
                dt_wk2: tempList[i].dt_wk2,
                status_B: tempList[i].status_B,
                rt_total: tempList[i].rt_total,
                ot_total: tempList[i].ot_total,
                dt_total: tempList[i].dt_total,
                sal_amnt: tempList[i].sal_amnt,
                holiday_hrs: tempList[i].holiday_hrs,
                sick_hrs: tempList[i].sick_hrs,
                pto_hrs: tempList[i].pto_hrs,
                covid_hrs: tempList[i].covid_hrs,
                training_hrs: tempList[i].training_hrs,
                gym_amnt: tempList[i].gym_amnt,
                fmla_amnt: tempList[i].fmla_amnt,
                sevpay_amnt: tempList[i].sevpay_amnt,
                bonus_amnt: tempList[i].bonus_amnt,
                missingInPaychexList: tempList[i].missingInPaychexList,
                insertDate: tempList[i].insertDate,
                payDate: newPaydt,
                ticket_Number: tempList[i].Ticket_Number,
                remarks: tempList[i].remarks
            })
        }
        return loopList
    } catch (err) {
        ErrorMessage("Unable to get data");
        return null;
    }
};
export const updateMasterfile = async (props) => {
    try {
        let data = props;
        let url = `${BaseUrl}Paychex/updatingMasterFileData`
        const response = await axios.put(url, data, JsonConfig)
        return response
    }
    catch (err) {
        ErrorMessage("Cannot able to update");
        return null;
    }
}
export const callPaychexUploadTemplateApi = async() => {
    try{
        let url = `${BaseUrl}Paychex/PaychexUploadTemplate`
        const response = await axios.get(url, JsonConfig)
        return response;
    }
    catch{
        ErrorMessage("Cannot able to get data");
    }
}